// extracted by mini-css-extract-plugin
export default {"Image":"Image_Image__MTM0Y","Image--with-max-width":"Image_Image--with-max-width__ZGEzO"};